module.exports = __webpack_public_path__ + "assets/img/free_18.862eab2f.png";